import React, { useEffect, useState } from "react";
import MovieCard from "../MovieCard";
import "./MovieListPage.css";

const MovieListPage = () => {
  const [movies, setMovies] = useState([]);
  const [genres, setGenres] = useState([]);
  const [selectedGenre, setSelectedGenre] = useState(null);
  const [loading, setLoading] = useState(false);

  // Lấy danh sách thể loại
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    fetch(`${baseUrl}/genres`)
      .then((res) => res.ok ? res.json() : Promise.reject())
      .then(setGenres)
      .catch(() => setGenres([]));
  }, []);

  // Lấy danh sách phim hoặc lọc theo thể loại
  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    setLoading(true);
    const url = selectedGenre
      ? `${baseUrl}/movies/genre?genreId=${selectedGenre}`
      : `${baseUrl}/movies?page=0&size=10`;

    fetch(url)
      .then((res) => res.ok ? res.json() : Promise.reject())
      .then((data) => setMovies(data.content || []))
      .catch(() => setMovies([]))
      .finally(() => setLoading(false));
  }, [selectedGenre]);

  return (
    <section className="movie-list-page">
      <div className="container">
        <h2 className="title">Thể loại phim</h2>

        <div className="filter-buttons">
          <button
            className={`btn ${selectedGenre === null ? "active" : ""}`}
            onClick={() => setSelectedGenre(null)}
          >
            All
          </button>
          {genres.map((genre) => (
            <button
              key={genre.id}
              className={`btn ${selectedGenre === genre.id ? "active" : ""}`}
              onClick={() => setSelectedGenre(genre.id)}
            >
              {genre.name}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
          </div>
        ) : movies.length === 0 ? (
          <p className="no-movies">No movies found.</p>
        ) : (
          <div className="movies-grid row">
            {movies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default MovieListPage;
